import { logger } from '@amzn/atoz-shiftapp-metrics';
export function useLocalStorage(props) {
    if (!localStorage) {
        logger.emitWarn('Local Storage is unavailable');
        return undefined;
    }
    if (!props.employeeId || !props.key) {
        return undefined;
    }
    var loadAll = function () {
        var serialized = localStorage.getItem(props.key);
        if (!serialized) {
            return undefined;
        }
        return JSON.parse(serialized);
    };
    var load = function () {
        if (!props.employeeId) {
            return undefined;
        }
        var allStates = loadAll();
        if (!allStates || !allStates[props.employeeId]) {
            return undefined;
        }
        return allStates[props.employeeId];
    };
    var save = function (data) {
        if (!props.employeeId) {
            return;
        }
        var allStates = loadAll();
        if (!allStates) {
            allStates = {};
        }
        allStates[props.employeeId] = data;
        var serialized = JSON.stringify(allStates);
        localStorage.setItem(props.key, serialized);
    };
    return {
        load: load,
        save: save,
        storageRestored: true // in web local storage doesn't need to be restored therefore this flag is always true
    };
}
